export default __webpack_public_path__ + "static/media/as.429aed56.png";